<template>
  <div>
    <folders-list-file-and-folder></folders-list-file-and-folder>
  </div>
</template>

<script>
import FoldersListFileAndFolder from "@/components/folders/folders-list-file-and-folder";
import {mapMutations} from "vuex";
export default {
  name: "folders-my-files",
  components: {FoldersListFileAndFolder},
  methods: {
    ...mapMutations(['setNameSectionFolders']),
  },
  mounted() {
    this.setNameSectionFolders('My Files')
  }
}
</script>

<style scoped>

</style>